import { checkoutShippingAddressesStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingAddresses";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

checkoutShippingAddressesStyles.pickUpAddress = {
    container: {
        css: css`
            display: none;
        `,
    },
};
checkoutShippingAddressesStyles.billingAddressGridItem = {
    css: css`
        display: none;
    `,
};
checkoutShippingAddressesStyles.shippingAddressGridItem = {
    width: 12,
};
checkoutShippingAddressesStyles.billingAddress = {
    addressDisplayAndFormGridItem: {
        css: css`
            padding-top: 25px;
            > address > p {
                color: ${COLORS.text.main};
            }
            > address > span {
                color: ${COLORS.text.main};
            }
        `,
    },
    addressBookModalCancelButton: {
        css: css`
            padding: 10px 34px;
            span[class^="TypographyStyle"] {
                line-height: ${TYPOGRAPHY.lineHeight.base};
            }
        `,
    },
};
checkoutShippingAddressesStyles.shippingAddress = {
    oneTimeAddressGridItem: {
        css: css`
            padding-top: 25px;
        `,
    },
    addressBookModalCancelButton: {
        css: css`
            padding: 10px 34px;
            background: ${COLORS.background.main};
            border: 2px solid ${COLORS.primary.base} !important;
            span[class^="TypographyStyle"] {
                color: ${COLORS.text.main};
                font-size: 14px;
                line-height: ${TYPOGRAPHY.lineHeight.base};
            }
        `,
    },
};
